export const environment = {
  production: false,
  passportUrl: 'https://test-passport.nibo.com.br',
  clientId: '6D3044D7-2C77-4D15-A443-6ED83614F2EE',
  clientSecret: '17D86F54AE704C79866AA81DC991A66A5281DCA9C2D2496CAA',
  accountantApiUrl: 'https://test-api-contador.nibo.com.br',
  // accountantApiUrl: 'http://localhost:59944',
  bigDataApiUrl: 'https://data.nibo.com.br/api',
  bigDataToken: '_JbLeQkOTMgLBGKEon7QpZT6crpIBHbKvmy-qTOkO8oyAzFuR181oQ==',
  // signalRHubUrl: 'https://br-nibo-tools.azurewebsites.net/api/',
  signalRHubUrl: 'https://br-nibo-classification-functions.azurewebsites.net/api',
  filesApiUrl: 'https://test-files.nibo.com.br',
  // filesApiUrl: 'http://localhost:56344',
  niboDocsRobotId: '00000000-0000-0000-0000-000000000000',
  niboObligationsRobotId: '11111111-1111-1111-1111-111111111111',
  niboInboxRobotId: '22222222-2222-2222-2222-222222222222',
  niboNFSERobotId: 'a9ddb0f9-49dd-47dc-8d43-1b3acb58c7f1',
  classificationApiUrl: 'http://localhost:7071',
  version: '2.14.5',
};

// export const environment = {
//   production: true,
//   passportUrl: 'https://passport.nibo.com.br',
//   clientId: 'D2CBFE38-9803-4DA0-8E2C-4E67F26BA9F5',
//   clientSecret: 'C3865D36795C46839C6060D9062E6C61E7D373041A834CCABC',
//   accountantApiUrl: 'https://api-contador.nibo.com.br',
//   bigDataApiUrl: 'https://data.nibo.com.br/api',
//   bigDataToken: '_JbLeQkOTMgLBGKEon7QpZT6crpIBHbKvmy-qTOkO8oyAzFuR181oQ==',
//   signalRHubUrl: 'https://br-nibo-classification-functions.azurewebsites.net/api',
//   filesApiUrl: 'https://arquivos.nibo.com.br',
//   niboDocsRobotId: '00000000-0000-0000-0000-000000000000',
//   niboObligationsRobotId: '11111111-1111-1111-1111-111111111111',
//   niboInboxRobotId: '22222222-2222-2222-2222-222222222222',
//   niboNFSERobotId: 'a9ddb0f9-49dd-47dc-8d43-1b3acb58c7f1',
//   classificationApiUrl: 'https://br-nibo-classification-api.azurewebsites.net',
//   version: '2.14.4',
// };
